import { createSSRApp, createApp as createCSRApp, ref } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus, { ID_INJECTION_KEY, ZINDEX_INJECTION_KEY } from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import App from './App.vue'
import { createAppRouter } from './router'
import { setupGuards } from './router/guards'
import { createAppI18n } from './i18n'
import '@/assets/styles/main.scss'

export function createApp() {
  const isSSR = import.meta.env.SSR
  const app = isSSR ? createSSRApp(App) : createCSRApp(App)
  const pinia = createPinia()
  const router = createAppRouter()
  const i18n = createAppI18n()

  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }

  // Element Plus SSR 需要提供 ID 注入，避免水合 ID 不匹配
  app.provide(ID_INJECTION_KEY, { prefix: 1024, current: 0 })
  app.provide(ZINDEX_INJECTION_KEY, { current: 2000 })

  app.use(pinia)
  app.use(router)
  app.use(ElementPlus, { locale: zhCn })
  app.use(i18n)

  setupGuards(router)

  return { app, router, pinia }
}
